<template>
    <div>
        <topTab ref="topTab" :tabData="tabData" @tabChange="changePages">
            <el-form :inline="true" :model="formInline" class="user-search">
                <el-form-item label="调拨单号：">
                    <el-input v-model="formInline.code" placeholder="请输入调拨单号" clearable size="small"></el-input>
                </el-form-item>
                <el-form-item label="调出门店：">
                    <el-select v-model="formInline.outStoreKeyId" placeholder="请选择调出门店" clearable size="small"
                        filterable @change="inputChange">
                        <el-option v-for="item in storeList" :key="item.keyId" :label="item.value"
                            :value="item.keyId"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="调入门店：">
                    <el-select v-model="formInline.inStoreKeyId" placeholder="请选择调入门店" clearable size="small" filterable
                        @change="inputChange">
                        <el-option v-for="item in storeList" :key="item.keyId" :label="item.value"
                            :value="item.keyId"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="是否确认">
                    <el-select v-model="formInline.isConfirm" placeholder="请选择状态" clearable size="small" filterable
                        @change="inputChange">
                        <el-option label="全部" :value="null"></el-option>
                        <el-option label="是" :value="true"></el-option>
                        <el-option label="否" :value="false"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="是否接收">
                    <el-select v-model="formInline.isReceive" placeholder="请选择状态" clearable size="small" filterable
                        @change="inputChange">
                        <el-option label="全部" :value="null"></el-option>
                        <el-option label="是" :value="true"></el-option>
                        <el-option label="否" :value="false"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="调拨时间：">
                    <el-date-picker clearable v-model="dateValue" size="small" type="daterange"
                        value-format="yyyy-MM-dd" format="yyyy-MM-dd" @change="handleDateChange" range-separator="至"
                        start-placeholder="开始日期" end-placeholder="结束日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button v-if="this.$checkBtnPermission('/transfer/dtl', 'viewPage')" size="small" type="primary"
                        class="el-icon-search" @click="inputChange()">
                        搜索
                    </el-button>
                </el-form-item>
            </el-form>
            <STable :columns="columnsData" :data="listData" :loading="loading" border stripe>
                <el-table-column slot="isConfirm" label="是否确认" width="100" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.isConfirm ? '是' : '否' }}
                    </template>
                </el-table-column>
                <el-table-column slot="isReceive" label="是否接收" width="100" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.isReceive ? '是' : '否' }}
                    </template>
                </el-table-column>
                <el-table-column slot="money" label="金额(元)" width="90" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.price * scope.row.quantity }}
                    </template>
                </el-table-column>
                <el-table-column v-if="seeAllData.indexOf(loginUserRoleId) != -1" slot="costMoney" label="成本(元)"
                    width="90" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.costMoney }}
                    </template>
                </el-table-column>
            </STable>
            <!-- 分页组件 -->
            <Pagination v-if="pageShow" v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
        </topTab>
    </div>
</template>

<script>
import {
    GetProductTransferRecordDtlPageList,
} from "@/api/productApi.js";
import {
    GetOrgInfoListByConfig,
    GetAllOrgInfoListByConfig
} from "@/api/organizationalApi.js";
import { GetSystemBusinessConfigDetailByCode } from "@/api/systemApi.js";
export default {
    data() {
        return {
            activeTab: "1",
            tabData: [
                {
                    key: "1",
                    value: "调拨明细",
                },
            ],
            pageShow: true,
            loading: false, // 显示加载
            listData: [],
            // 分页参数
            pageparm: {
                pageIndex: 1,
                pageSize: 10,
                total: 0,
            },
            formInline: {
                pageIndex: 1,
                pageSize: 10,
                code: '',
                inStoreKeyId: '',
                outStoreKeyId: '',
                isConfirm: null,
                isReceive: null,
                startTime: null,
                endTime: null
            },
            columnsData: [],
            listColumns: [
                {
                    prop: "rowNumber",
                    label: "序号",
                    align: "center",
                    fixed: "left",
                    width: "80",
                    isKeep: true,
                },
                {
                    prop: "createTime",
                    label: "创建时间",
                    width: "170",
                    align: "center",
                    fixed: "left",
                    isKeep: true,
                },
                {
                    prop: "outStoreName",
                    label: "调出门店",
                    isKeep: true,
                    width: "140",
                    align: "center",
                    fixed: "left",
                },
                {
                    prop: "inStoreName",
                    label: "调入门店",
                    isKeep: true,
                    width: "120",
                    align: "center",
                    fixed: "left",
                },
                {
                    prop: "productInfo.specification",
                    label: "商品名称",
                    width: "200",
                    align: "center",
                },
                {
                    prop: "quantity",
                    label: "数量",
                    width: "90",
                    align: "center",
                },
                {
                    prop: "recordCode",
                    label: "调拨单编号",
                    width: "180",
                    align: "center",
                },
                {
                    prop: "code",
                    label: "商品编码",
                    width: "200",
                    align: "center",
                },
                {
                    prop: "productInfo.typeName",
                    label: "类型",
                    width: "120",
                    align: "center",
                },
                {
                    prop: "productInfo.productName",
                    label: "系列",
                    width: "150",
                    align: "center",
                },
                {
                    prop: "price",
                    label: "价格(元)",
                    width: "90",
                    align: "center",
                },
                {
                    slot: "costMoney",
                    label: "成本(元)",
                    width: "90",
                    align: "center",
                },
                {
                    slot: "money",
                    label: "金额(元)",
                    width: "90",
                    align: "center",
                },
                {
                    slot: "isConfirm",
                    label: "是否确认",
                    width: "100",
                    align: "center",
                },
                {
                    prop: "confirmUserName",
                    label: "确认人",
                    width: "90",
                    align: "center",
                },
                {
                    prop: "confirmDate",
                    label: "确认时间",
                    width: "160",
                    align: "center",
                },
                {
                    slot: "isReceive",
                    label: "是否接收",
                    width: "100",
                    align: "center",
                },
                {
                    prop: "receiveUserName",
                    label: "接收人",
                    width: "90",
                    align: "center",
                },
                {
                    prop: "receiveTime",
                    label: "接收时间",
                    width: "160",
                    align: "center",
                },
                {
                    prop: "remark",
                    label: "备注",
                    width: "120",
                    align: "center",
                },
                {
                    prop: "creator",
                    label: "创建人",
                    width: "120",
                    align: "center",
                },
            ],
            storeList: [],
            allStoreList: [],
            dateValue: [],
            seeAllData: "",
            loginUserRoleId: ''
        };
    },
    // 注册组件
    components: {

    },
    created() {
        // 初始列
        this.getCheckBox(this.listColumns.map((item) => item.label));
        this.getListData();
        this.GetOrgInfoListByConfig();
        this.GetAllOrgInfoListByConfig();
        this.GetSystemBusinessConfigDetailByCode();
        var loginInfo = JSON.parse(localStorage.getItem("userdata"));
        this.loginUserRoleId = loginInfo.roleInfo.keyId;
    },
    computed: {},
    methods: {
        // 获取筛选框
        getCheckBox(val) {
            let arr = this.listColumns.filter((v) => !val.includes(v.label));
            this.columnsData = this.listColumns.filter((i) => !arr.includes(i));
        },
        changePages() { },
        // 获取列表
        getListData() {
            this.loading = true;
            GetProductTransferRecordDtlPageList(this.formInline)
                .then((res) => {
                    if (res.code == 1) {
                        this.loading = false;
                        this.listData = res.data;
                        this.pageparm.total = res.totalNumber;
                    } else {
                        this.$message({
                            type: "info",
                            message: res.msg,
                        });
                    }
                })
                .catch((err) => {
                    this.loading = false;
                    this.$message.error("数据加载失败，请稍后再试！");
                });
        },
        inputChange() {
            this.search();
        },
        // 分页插件事件
        callFather(parm) {
            if (parm.currentPage == undefined) {
                this.formInline.pageIndex = 1;
            } else {
                this.formInline.pageIndex = parm.currentPage;
            }
            this.formInline.pageSize = parm.pageSize;
            this.getListData();
        },
        // 搜索事件
        search() {
            this.formInline.pageIndex = 1;
            this.pageShow = false;
            this.$nextTick(() => {
                this.pageShow = true;
            });
            this.getListData();
        },
        // 获取所属门店
        GetOrgInfoListByConfig() {
            const paramer = {
                key: 1,
            };
            GetOrgInfoListByConfig(paramer)
                .then((res) => {
                    if (res.code == 1) {
                        this.storeList = [];
                        if (res.code == 1) {
                            res.data.forEach((item) => {
                                this.storeList.push({
                                    keyId: item.keyId,
                                    value: item.name + '【' + item.remark2 + '】',
                                });
                            });
                            this.storeList.unshift({
                                keyId: '',
                                value: '全部门店',
                            });
                        } else {
                            this.$message.error(res.msg);
                        }
                    } else {
                        this.$message.error(res.msg);
                    }
                })
                .catch((err) => {
                    this.loading = false;
                    this.$message.error("获取门店信息失败!");
                });
        },
        // 获取所有门店
        GetAllOrgInfoListByConfig() {
            const paramer = {
                key: 1,
            };
            GetAllOrgInfoListByConfig(paramer)
                .then((res) => {
                    if (res.code == 1) {
                        this.allStoreList = [];
                        if (res.code == 1) {
                            res.data.forEach((item) => {
                                this.allStoreList.push({
                                    keyId: item.keyId,
                                    value: item.name + '【' + item.remark2 + '】',
                                });
                            });
                            this.allStoreList.unshift({
                                keyId: '',
                                value: '全部门店',
                            });
                        } else {
                            this.$message.error(res.msg);
                        }
                    } else {
                        this.$message.error(res.msg);
                    }
                })
                .catch((err) => {
                    this.loading = false;
                    this.$message.error("获取门店信息失败!");
                });
        },
        // 日期选择器改变事件
        handleDateChange(val) {
            if (val) {
                this.formInline.startTime = val[0];
                this.formInline.endTime = val[1];
            } else {
                this.formInline.startTime = null;
                this.formInline.endTime = null;
            }
            this.getListData();
        },
        // 获取系统业务配置详情
        GetSystemBusinessConfigDetailByCode() {
            const paramer = {
                code: "SeeAllData",
            };
            GetSystemBusinessConfigDetailByCode(paramer)
                .then((res) => {
                    if (res.code == 1) {
                        this.seeAllData = res.data.value;
                    } else {
                        this.$message.error(res.msg);
                    }
                })
                .catch((err) => {
                    this.loading = false;
                    this.$message.error("获取运费配置失败!");
                });
        },
    },
};
</script>

<style scoped></style>